<!-- Preloader -->
<div class="preloader">
    <div class="loader-container">
        <div class="spinner"></div>        
    </div>
</div>
<!-- End Preloader -->